import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

interface AdvertisementModalProps {
  onClose: () => void;
  shouldShow: boolean;
  url: any;
  type: any;
}

export default function AdvertisementModal({ onClose, shouldShow, type, url }: AdvertisementModalProps) {
  const [time, setTime] = useState<any>(type == "image" ? 5 : 15);
  const [intervalIds, setIntervalIds] = useState<any>([]);

  useEffect(() => {
    if (time == 0) {
      onClose();
      //   return;
    }
    const id = setInterval(() => {
      setTime(time - 1);
    }, 1000);
    const x = intervalIds?.length ? [...intervalIds] : [];
    x.push(id);
    setIntervalIds(x);
    // console.log({ id });
    return () => {
      const y = [...intervalIds];
      //   console.log({ y });
      y.map((i: any) => clearInterval(i));
    };
  }, [time]);

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body bsPrefix={"main-container"}>
          {type == "image" && (
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close btn-close-white"
                aria-label="Close"
                onClick={() => onClose()}
              ></button>
            </div>
          )}
          <div className="modal-body">
            {type == "image" && <h2 className="info-txt">Promo image closes in {time} seconds...</h2>}
            {type == "video" ? (
              <video
                id="promoVid"
                src={url}
                preload="auto"
                autoPlay={true}
                muted={true}
                width="100%"
                height="100%"
                onEnded={() => onClose()}
              ></video>
            ) : (
              <img src={url} style={{ width: "100%" }} />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
